import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Row, Col } from 'antd';
import { Paper, TablePagination } from '@material-ui/core';
import { get, getVal } from '../../../../shared/helpers';
import Table from './LeadsTable';
import { getLeadsRequest, setLeadManageKey, setLeadManagePagination } from '../redux/actions/get_leads.actions';
import { getUsersList } from '../redux/actions/get_users_list.actions';
import {
    LEADS_MANAGE_TABS,
    LEADS_MANAGE_LEADOMATIC_TABS,
} from '../contants/filter.constants';

const { TabPane } = Tabs;

class LeadList extends Component {
    componentDidMount() {
        if (!this.props.isLeadManageLeadomatic && this.props.active_lead_manage_tab === 0) {
            // Set is_trade: undefined for the first render of Retail Page (by default All leads tab is active)
            this.props.setLeadManageKey('filters', { is_trade: undefined });
        }
    }

    toggle = (tab, filter, filterValue) => {
        if (this.props.active_lead_manage_tab !== tab) {
            const nextFilters = {
                hideDuplicate: get(this.props, 'filters.hideDuplicate') || false,
                is_part_ex: undefined,
                ref_assigned_to: get(this.props, 'filters.ref_assigned_to') || undefined,
                is_hot: false,
                served_live_price: undefined,
                ref_lead_status: undefined,
                lead_pot: undefined,
                is_manager_special: get(this.props, 'filters.hideDuplicate') || false,
                ref_lead_source: undefined,
                // Leadomatic page: all the tabs have isTrade = false
                // Retail page: 'All Leads' tab has isTrade = undefined, Trade and Scrap have isTrade = true, other tabs have isTrade = false
                is_trade: false,
            };

            if (this.props.isLeadManageLeadomatic) {
                nextFilters.ref_lead_source = '5be93e5f683059f77dbcef4c';
            }

            // TIP: with help of this.props.isLeadManageLeadomatic you can add condition that needed for LeadsManageLeadomatic
            if (filter !== 'ref_assigned_to' && get(this.props, 'filters.ref_assigned_to') === get(this.props, 'currentUser._id')) {
                nextFilters.ref_assigned_to = undefined;
            }

            // Leadomatic page: all the tabs have isTrade = false
            // Retail page: 'All Leads' tab has isTrade = undefined, Trade and Scrap have isTrade = true, other tabs have isTrade = false
            if (filter === 'all' && !this.props.isLeadManageLeadomatic) {
                nextFilters.is_trade = undefined;
            }

            if (filter === 'all') {
                nextFilters.hideDuplicate = false;
            }

            if (filter === 'pending') {
                nextFilters.hideDuplicate = false;
                nextFilters.ref_lead_status = '5beabfe7f25bf5f49685abfb';
            }

            if (filter === 'autopriced') {
                nextFilters.served_live_price = true;
            }
            if (filter === 'ref_assigned_to') {
                nextFilters.ref_assigned_to = filterValue;
            }
            if (filter === 'is_part_ex') {
                nextFilters.is_part_ex = true;
            }
            if (filter === 'is_hot') {
                nextFilters.is_hot = true;
            }
            if (filter === 'is_trade') {
                nextFilters.is_trade = true;
            }
            if (filter === 'scrap') {
                nextFilters.is_trade = true;
                nextFilters.lead_pot = 'Black';
            }

            this.props.setLeadManageKey('active_lead_manage_tab', tab);
            this.props.setLeadManageKey('filters', nextFilters);
            this.props.getLeadsRequest();
        }
    };

    TabChange = (tab) => {
        switch (tab) {
        case '1':
            this.toggle(tab, 'pending');
            break;
        case '2':
            this.toggle(tab, 'autopriced');
            break;
        case '3':
            this.props.getUsersList(getVal(this.props.currentUser, 'person.first_name'));
            this.toggle(tab, 'ref_assigned_to', this.props.currentUser._id);
            break;
        case '4':
            this.toggle(tab, 'is_part_ex');
            break;
        case '5':
            this.toggle(tab, 'is_trade');
            break;
        case '6':
            this.toggle(tab, 'scrap');
            break;
        case '0':
        default:
            this.toggle(tab, 'all');
            break;
        }
    };

    changePage = (event, page) => {
        if (event) {
            const { setLeadManagePagination: setLeadManagePaginationCall } = this.props;

            setLeadManagePaginationCall('pagination', {
                'pagination.page': page,
            });

            this.props.getLeadsRequest();
        }
    };

    handleChangeRowsPerPage = (event) => {
        if (event) {
            const rpp = event.target.value;
            const { setLeadManagePagination: setLeadManagePaginationCall } = this.props;

            setLeadManagePaginationCall('pagination', {
                'pagination.rows_per_page': rpp,
                'pagination.page': 0,
            });

            this.props.getLeadsRequest();
        }
    };

    render() {
        let filterTabs = LEADS_MANAGE_TABS;
        const { isLeadManageLeadomatic, isLeadManageDeliveryRequested, leads, pagination } = this.props;

        const leadsLength = leads?.length;
        const displayDataList = leadsLength < pagination.rows_per_page ? leadsLength : pagination.rows_per_page * (pagination.page + 2);

        if (isLeadManageLeadomatic) {
            filterTabs = LEADS_MANAGE_LEADOMATIC_TABS;
        }

        return (
            <Paper>
                <Row>
                    <Col span={16}>
                        {!isLeadManageDeliveryRequested && (
                            <Tabs activeKey={String(this.props.active_lead_manage_tab)} onChange={this.TabChange}>
                                {filterTabs.map((tab, index) => <TabPane tab={tab} key={index} />)}
                            </Tabs>
                        )}
                    </Col>
                    <Col span={8}>
                        <TablePagination
                            rowsPerPageOptions={[100, 250, 500]}
                            component="div"
                            count={displayDataList}
                            rowsPerPage={this.props.pagination.rows_per_page}
                            page={this.props.pagination.page}
                            backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                            nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                            onPageChange={this.changePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            labelDisplayedRows={() => {}}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col span={24}>
                        <Table
                            parent={this}
                            lead_profile_access={this.props.lead_profile_access}
                            isLeadManageLeadomatic={isLeadManageLeadomatic}
                            isLeadManageDeliveryRequested={isLeadManageDeliveryRequested}
                        />
                    </Col>
                </Row>
            </Paper>
        );
    }
}

const mapStateToProps = (state) => ({
    currentUser: get(state.App, 'App_content.user'),
    filters: state.Leads.Leads_manage.filters,
    pagination: state.Leads.Leads_manage.pagination,
    active_lead_manage_tab: state.Leads.Leads_manage.active_lead_manage_tab,
    leads: state.Leads.Leads_manage.leads,
    leadsCount: state.Leads.Leads_manage.leadsCount,
});

export default connect(mapStateToProps, {
    setLeadManageKey,
    getLeadsRequest,
    getUsersList,
    setLeadManagePagination,
})(LeadList);



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/components/LeadList.js